import Paragraph from '@/design_system/Typography/Paragraph';
import IconCheck from '@/icons/Check.svg';
import { createBEMClasses } from '@/utils/classname';

import './StepperNumberItem.css';

export interface StepperNumberItemProps {
  number: number;
  label: string;
  status: 'pending' | 'current' | 'completed';
}

const { block, element } = createBEMClasses('stepper-number-item');

export const StepperNumberItem = ({ number, label, status }: StepperNumberItemProps) => {
  const isCurrent = status === 'current';
  const isCompleted = status === 'completed';

  return (
    <div className={block()} aria-current={isCurrent ? 'step' : false}>
      <div
        className={element('step-number', {
          current: isCurrent,
          completed: isCompleted,
        })}
      >
        {isCompleted ? <IconCheck /> : number}
      </div>
      <div
        className={element('step-label', {
          current: isCurrent,
        })}
      >
        <Paragraph weight="medium">{label}</Paragraph>
      </div>
    </div>
  );
};
